import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { setOrdersToRetrieveFilters } from '../../../orderSlice';

export default function useObserveBottomCard({
  filters,
  bottomInView,
  loadMoreBottomRef,
  setIsLoadingMore,
  totalPages,
}) {
  const dispatch = useDispatch();
  // If last card is inside the viewPort, calls hook above to fetch more orders
  useEffect(() => {
    const { page, ...rest } = filters;

    if (bottomInView && loadMoreBottomRef.current) {
      loadMoreBottomRef.current = false;

      setIsLoadingMore(true);
      dispatch(
        setOrdersToRetrieveFilters({
          page: filters.page + 1,
          ...rest,
        })
      );
    }
  }, [
    bottomInView,
    filters,
    totalPages,
    dispatch,
    loadMoreBottomRef,
    setIsLoadingMore,
  ]);
}
